import { render, staticRenderFns } from "./formedit.vue?vue&type=template&id=2c9030b0"
import script from "./formedit.vue?vue&type=script&lang=js"
export * from "./formedit.vue?vue&type=script&lang=js"
import style0 from "./formedit.vue?vue&type=style&index=0&id=2c9030b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports